<template>
    <sui-modal
            v-model="showModalDialog"
            style="z-index: 21000;"
            :closable="false"
    >
        <sui-modal-header>Параметры района наблюдения</sui-modal-header>
        <sui-modal-content>
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
            >
                <v-container>
                    <v-layout row wrap>

                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Периодичность съемки"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.shootingFrequency"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Диапазон допустимых углов Солнца"
                                    color="blue darken-2"
                                    v-model="entity.sunAnglesRange"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Приоритет территории"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.territoryPriority"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Максимально допустимый угол крена"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.maxRollAngle"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Уровень обработки"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.processingLevel"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Примечание"
                                    color="blue darken-2"
                                    v-model="entity.note"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <div style="display: flex;justify-content: flex-end">
                    <v-btn round color="blue darken-2" dark
                           :disabled="!valid"
                           @click="onSaveButtonClick"
                    >
                        сохранить
                    </v-btn>
                    <v-btn round flat
                           @click="showModalDialog=false"
                    >
                        отмена
                    </v-btn>
                </div>
            </v-form>
        </sui-modal-content>
    </sui-modal>
</template>

<script>
    import Vue from 'vue'

    import {pickBy} from 'lodash/object'

    export default {
        props: {
            value: {
                type: Object,
                default: () => ({})
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showModalDialog: this.show,
                entity: this.copyEntity(this.value),
                valid: true
            }
        },
        computed: {},
        methods: {
            onSaveButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$emit('aoiUpdated', pickBy(this.entity, v => v !== undefined));
                    this.showModalDialog = false;
                }
            },
            copyEntity(val) {
                val = val || {};
                const {shootingFrequency, sunAnglesRange, territoryPriority, maxRollAngle, processingLevel, note} = val;
                return {shootingFrequency, sunAnglesRange, territoryPriority, maxRollAngle, processingLevel, note}
            }
        },

        components: {},
        watch: {
            show(newVal) {
                this.showModalDialog = newVal;
            },
            showModalDialog(newVal) {
                this.$emit('update:show', newVal);
            },
            value(newVal) {
                this.entity = this.copyEntity(newVal);
            }
        }

    }
</script>

<style>

</style>
